/**
 * AppRoutes.js
 * @author Jaiván Piña
 */

//Dependencies
import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

//Components
import App from './components/App';
import NotFound from './components/NotFound/NotFound';
//TODO: Eliminar Pasos
//OnBoarding
import Paso0 from './components/OnBoarding/Paso0';
import Paso1 from './components/OnBoarding/Paso1';
import Paso3 from './components/OnBoarding/Paso3';
import Paso5 from './components/OnBoarding/Paso5';
import Paso7 from './components/OnBoarding/Paso7';
import Paso8 from './components/OnBoarding/Paso8';
import Paso9 from './components/OnBoarding/Paso9';
import Felicitaciones from './components/OnBoarding/Felicitaciones';
import PantallaEspera from './components/OnBoarding/PantallaEspera';

//OnBoarding Errores
import ErrorStandAlone from './components/OnBoarding/error/ErrorStandAlone';
import ErrorServicio from './components/OnBoarding/error/ErrorServicio';
import ErrorVU from './components/OnBoarding/error/ErrorVU';
import ErrorDNI from './components/OnBoarding/error/ErrorDNI';
import ErrorRostro from './components/OnBoarding/error/ErrorRostro';
import ErrorPruebaVida from './components/OnBoarding/error/ErrorPruebaVida';
import ErrorIdentidad from './components/OnBoarding/error/ErrorIdentidad';
import ErrorVenta from './components/OnBoarding/error/ErrorVenta';
import SinReintentos from './components/OnBoarding/error/SinReintentos';
//Plazo fijo 
import LandingPage from './components/PlazoFijo/landingPage/LandingPage';
import DatosBasicos from './components/PlazoFijo/datosBasicos/DatosBasicos';
import DatosPersonales from './components/PlazoFijo/datosPersonales/DatosPersonales';
import Congrats from './components/PlazoFijo/congrats/Congrats';
//Plazo fijo Errores 
import ErrorIniciar from './components/PlazoFijo/error/ErrorIniciar';
import ErrorYaEsCliente from './components/PlazoFijo/error/ErrorYaEsCliente';
import ErrorPlazoFijo from './components/PlazoFijo/error/ErrorPlazoFijo';

//Data
//import items from './data/url';

const AppRoutes = (items) =>
    //TODO: App base header y fotter
    //<BrowserRouter basename={'/onboarding/'}>
    <App>
        <Switch>
            <Route exact path="/reconocimiento-facial/:id" component={Paso0} />
            <Route exact path="/paso-1" component={Paso1} />
            <Route exact path="/paso-3" component={Paso3} />
            <Route exact path="/paso-5" component={Paso5} />
            <Route exact path="/paso-7" component={Paso7} />
            <Route exact path="/paso-8" component={Paso8} />
            <Route exact path="/cargando-venta" component={PantallaEspera} />
            <Route exact path="/tyc" component={Paso9} />
            <Route exact path="/felicitaciones" component={Felicitaciones} />
            <Route exact path="/error-validacion-imagen" component={ErrorVU} />
            <Route exact path="/error-dni" component={ErrorDNI} />
            <Route exact path="/error-rostro" component={ErrorRostro} />
            <Route exact path="/error-prueba-vida" component={ErrorPruebaVida} />
            <Route exact path="/error-identidad" component={ErrorIdentidad} />
            <Route exact path="/error-resolucion" component={ErrorVenta} />
            <Route exact path="/sin-reintentos" component={SinReintentos} />
            <Route exact path="/error-servicio" component={ErrorServicio} />
            <Route exact path="/error-standalone" component={ErrorStandAlone} />

            {/* Plazo Fijo */}
            <Route exact path="/" component={LandingPage} />
            <Route exact path="/plazo-fijo" component={LandingPage} />
            <Route exact path="/plazo-fijo/PF-info-basica" component={DatosBasicos} />
            <Route exact path="/plazo-fijo/PF-info-personal" component={DatosPersonales} />
            <Route exact path="/plazo-fijo/PF-congrats" component={Congrats} />
            {/* 404 */}
            <Route exact path="/plazo-fijo/PF-fail" component={ErrorPlazoFijo} />
            <Route exact path="/plazo-fijo/PF-solicitud-no-procesada" component={ErrorIniciar} />
            <Route exact path="/plazo-fijo/PF-cliente-existente" component={ErrorYaEsCliente} />
            <Route component={NotFound} />
        </Switch>
    </App>
    // </BrowserRouter> 
    ;
export default AppRoutes;


// WEBPACK FOOTER //
// ./src/Routes.js